import { BlockData } from 'types';
import { FLOW_TYPE } from 'constants/flow';

interface CreateBlockNodeDragDataParams {
  nodeType: string;
  blockData: BlockData;
}

export const createBlockNodeDragData = ({ nodeType, blockData }: CreateBlockNodeDragDataParams) => {
  const parameters = blockData.parameters.map((parameter) => {
    let value = parameter.defaultValue;

    if (value === '_Optional') {
      value = null;
    } else if (typeof value === 'boolean') {
      value = JSON.stringify(value);
      value = value.charAt(0).toUpperCase() + value.slice(1);
    }

    return {
      ...parameter,
      value,
    };
  });

  return {
    type: nodeType,
    data: {
      ...blockData,
      parameters,
      expand: false,
    },
  };
};

interface CreateDataNodeDragDataParams {
  blockData: BlockData;
}

export const createDataNodeDragData = ({ blockData }: CreateDataNodeDragDataParams) => {
  const parameters = blockData.parameters.map((parameter) => ({
    ...parameter,
    value: parameter.value ?? parameter.defaultValue,
  }));

  return {
    type: FLOW_TYPE.NODE.DATA_NODE,
    data: {
      ...blockData,
      parameters,
      expand: false,
    },
  };
};
